<template>
  <div class="d-flex justify-content-left my-1" @click="handleClick">
    <div class="col-1 mr-2">
      <BS-Icon :_class="icon" :_style="style" />
    </div>
    <label class="col-11 px-4 align-self-center" style="color: inherit">{{ label }}</label>
  </div>
</template>

<script>
import Icon from '@/Components/BS-Icon'

export default {
  name: 'SidebarLinkItem',
  components: {
    Icon,
  },
  props: {
    label: String,
    icon: String,
    color: String,
    url: { type: String, required: true },
  },
  computed: {
    style() {
      return `font-size: 2rem` + (this.color ? `color: ${this.color}` : '')
    },
  },
  methods: {
    handleClick() {
      if (this.url) window.open(this.url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
div:hover {
  color: white !important;
  cursor: pointer;
  label {
    cursor: pointer;
  }
}
</style>
